import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FilterSelectProps {
  id: string;
  label: string;
  allLabel: string;
  value: string;
  options: string[];
  onChange: (value: string) => void;
}
export function FilterSelect({
  id,
  label,
  allLabel,
  value,
  options,
  onChange
}: FilterSelectProps) {
  return <div data-id="element-384" data-mp="r2fytj4x73b2">
      <label htmlFor={id} className="block text-xs font-medium text-plum/65" data-id="element-385" data-mp="r2pqdb5m5iiv">
        {label}
      </label>
      <div className="relative mt-1.5" data-id="element-386" data-mp="m5h5v3wzt2eg">
        <select id={id} value={value} onChange={e => onChange(e.target.value)} className="block h-11 w-full appearance-none rounded-lg border border-plum/15 bg-white pl-3.5 pr-9 text-sm text-plum transition-[border-color] duration-150 hover:border-plum/30 focus:border-copper focus:outline-none focus:ring-2 focus:ring-copper/25" data-id="element-387" data-mp="i2suopkt3jeb">
          <option value="" data-id="element-388" data-mp="27f4pwfvgqv0c">{allLabel}</option>
          {options.map(o => <option key={o} value={o} data-id="element-389" data-mp="22j7f0p2yyguy">
              {o}
            </option>)}
        </select>
        <ChevronDownIcon className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-plum/50" aria-hidden="true" data-id="element-390" data-mp="nh9qjeoi7mys" />
      </div>
    </div>;
}